/* eslint-disable indent */
// Components
import { RaiseChargeBackComponent } from '../ChargebackComponents';
import { ConditionalComponent } from '../index';
import {
    TRANSACTION_STATUS,
    TRANSACTION_TYPE,
} from '../../utils/constants/commonValues';

// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Styles
import './transactionForm.scss';
import { isAdminUser } from '../../utils/helperMethods';

const TransactionForm = props => {
    const {
        data,
        statusData,
        fetchStatus,
        getRefundTxnRequest,
        refundTxnData,
        auth,
        raiseChargeBackRequest,
    } = props;
    const getStatus = () => {
        const request = {
            merchantId: data.merchantId || '',
            merchantTxnId: data.orderId || '',
            txnReferenceId: data.transactionReferenceNumber || '',
        };
        fetchStatus(request);
    };
    useEffect(() => {
        getRefundTxnRequest({
            entityTransactionId: statusData.orderId || data.orderId,
            transactionId:
                statusData.transactionReferenceNumber ||
                data.transactionReferenceNumber,
        });
    }, [
        data.orderId,
        data.transactionReferenceNumber,
        getRefundTxnRequest,
        statusData.orderId,
        statusData.transactionReferenceNumber,
    ]);

    return (
        <>
            <form className="transactions-view">
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Customer Name</p>
                        <p className="user-text">{data.customerName}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Customer ID</p>
                        <p className="user-text">{data.customerID}</p>
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">FCPG TXN ID</p>
                        <p className="user-text">
                            {statusData.transactionReferenceNumber ||
                                data.transactionReferenceNumber}
                        </p>
                    </div>
                    <div className="form-field">
                        <p className="label">Merchant TXN ID</p>
                        <p className="user-text">
                            {statusData.orderId || data.orderId}
                        </p>
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">ARN/RRN</p>
                        <p className="user-text">{data.rrnArn}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Date Time</p>
                        <p className="user-text">
                            {data.transactionDateAndTime}
                        </p>
                    </div>
                </div>
                <div className="form-section">
                    {data.paymentMode === 'UPI' ? (
                        <div className="form-field">
                            <p className="label">Payee VPA</p>
                            <div className="user-text">{data.payeeVpa}</div>
                        </div>
                    ) : (
                        <div className="form-field">
                            <p className="label">Card Number</p>
                            <div className="user-text">
                                {data.maskedCardNumber}
                            </div>
                        </div>
                    )}

                    {data.paymentMode === 'UPI' && (
                        <div className="form-field">
                            <p className="label">Payer VPA</p>
                            <div className="user-text">{data.payerVpa}</div>
                        </div>
                    )}
                </div>
                <div className="form-section three">
                    <div className="form-field">
                        <p className="label">Amount</p>
                        <p className="user-text">
                            {statusData.transactionAmount ||
                                data.transactionAmount}
                        </p>
                    </div>
                    <div className="form-field">
                        <p className="label">Payment Mode</p>
                        <p className="user-text">{data.paymentMode}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Transaction Type</p>
                        <p className="user-text">
                            {statusData.transactionType || data.transactionType}
                        </p>
                    </div>
                </div>
                {data.paymentMode === 'EMI_CREDIT_CARD' ? (
                    <>
                        <div className="form-section three">
                            <div className="form-field">
                                <p className="label">Loan Amount</p>
                                <p className="user-text">{data.loanAmount}</p>
                            </div>
                            <div className="form-field">
                                <p className="label">EMI Amount</p>
                                <p className="user-text">{data.emiAmount}</p>
                            </div>
                            <div className="form-field">
                                <p className="label">Bank Interest</p>
                                <p className="user-text">
                                    {data.emiBankInterest}
                                </p>
                            </div>
                        </div>
                        <div className="form-section three">
                            <div className="form-field">
                                <p className="label">EMI Value</p>
                                <p className="user-text">{data.emiValue}</p>
                            </div>
                            <div className="form-field">
                                <p className="label">Interest Paid</p>
                                <p className="user-text">
                                    {data.emiInterestPaid}
                                </p>
                            </div>
                            <div className="form-field">
                                <p className="label">Tenure</p>
                                <p className="user-text">{data.tenure}</p>
                            </div>
                        </div>
                    </>
                ) : (
                    <></>
                )}
                <div className="form-section three">
                    <div className="form-field">
                        <p className="label">
                            Status
                            {statusData.transactionStatus === 'Pending' ||
                            data.transactionStatus === 'Pending' ? (
                                <span
                                    className="status-action"
                                    onClick={getStatus}
                                >
                                    ( Check Status )
                                </span>
                            ) : null}
                        </p>
                        <p
                            className={`user-text status ${statusData.transactionStatus ||
                                data.transactionStatus}`}
                        >
                            {statusData.transactionStatus ||
                                data.transactionStatus}
                        </p>
                    </div>
                    <div className="form-field">
                        <p className="label">Status Code</p>
                        <p className="user-text">{data.statusCode}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Platform</p>
                        <p className="user-text">{data.platform}</p>
                    </div>
                </div>
                <div className="form-section message-section">
                    <div className="form-field">
                        <p className="label">Message</p>
                        <p className="message-text">{data.message}</p>
                    </div>
                </div>
                {/**
                 * split pay
                 */}
                {data?.splitPay?.length > 0 && (
                    <div className="split-payment-container">
                        <div className="split-heading">
                            SPLIT PAYMENT DETAIL
                        </div>
                        {data.splitPay.map(splitPay => {
                            return (
                                <div className="split-payment">
                                    <div className="list">
                                        <div className="form-field">
                                            <p className="label">
                                                Merchant Name
                                            </p>
                                            <p className="user-text">
                                                {splitPay.merchantName}
                                            </p>
                                        </div>
                                        <div className="form-field">
                                            <p className="label">
                                                Sub Order ID
                                            </p>
                                            <p className="user-text">
                                                {splitPay.subOrderId}
                                            </p>
                                        </div>
                                        <div className="form-field">
                                            <p className="label">Amount</p>
                                            <p className="user-text">
                                                {splitPay.amount}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {/**
                 * refund txn data
                 */}
                {refundTxnData.length > 0 && (
                    <div className="refund-payment-container">
                        <div className="refund-heading">Refund Txn. DETAIL</div>
                        {refundTxnData.map(refund => {
                            return (
                                <div className="refund-payment">
                                    <div className="list">
                                        <div className="form-field">
                                            <p className="label">
                                                Transaction Id
                                            </p>
                                            <p className="user-text">
                                                {refund.transactionId}
                                            </p>
                                        </div>
                                        <div className="form-field">
                                            <p className="label">
                                                Refund Status
                                            </p>
                                            <p className="user-text">
                                                {refund.refundStatus}
                                            </p>
                                        </div>
                                        <div className="form-field">
                                            <p className="label">Refund Date</p>
                                            <p className="user-text">
                                                {refund.refundDate}
                                            </p>
                                        </div>
                                        <div className="form-field">
                                            <p className="label">Amount</p>
                                            <p className="user-text">
                                                {refund.amount}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </form>
            <ConditionalComponent
                isVisible={
                    (statusData.transactionType === TRANSACTION_TYPE.PAY ||
                        data.transactionType === TRANSACTION_TYPE.PAY) &&
                    (statusData.transactionStatus ===
                        TRANSACTION_STATUS.SUCCESS ||
                        data.transactionStatus ===
                            TRANSACTION_STATUS.SUCCESS) &&
                    isAdminUser(auth)
                }
            >
                <RaiseChargeBackComponent
                    isTransactionPage
                    transactionPageData={data}
                    raiseChargeBackRequest={raiseChargeBackRequest}
                />
            </ConditionalComponent>
        </>
    );
};

TransactionForm.propTypes = {
    data: PropTypes.object.isRequired,
    statusData: PropTypes.object,
    auth: PropTypes.object,
    refundTxnData: PropTypes.object,
    fetchStatus: PropTypes.func.isRequired,
    getRefundTxnRequest: PropTypes.func.isRequired,
    fetchData: PropTypes.func.isRequired,
    resetPage: PropTypes.func,
};

export default TransactionForm;
